import { render } from "./VideoPopup.vue?vue&type=template&id=6c3a5142&scoped=true"
import script from "./VideoPopup.vue?vue&type=script&lang=js"
export * from "./VideoPopup.vue?vue&type=script&lang=js"

import "./VideoPopup.vue?vue&type=style&index=0&id=6c3a5142&scoped=true&lang=css"
import "./VideoPopup.vue?vue&type=style&index=1&id=6c3a5142&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/core_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c3a5142"]])

export default __exports__